/** Desktop header utility icon / profile / more menu clicks. */
export const HEADER_CTA_CLICKED = 'Header CTA Clicked';

export function headerCtaClickedEventProperties(buttonName: string): Record<string, string> {
  return {
    'Button Name': buttonName,
  };
}
